import React from "react";
import QuestionGroup from "./QuestionGroup";
import { ISurveySection, IQuestionGroup, IQuestionType } from "../surveyTypes";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  surveySection: {
    padding: theme.spacing(),
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  questionGroup: {
    margin: theme.spacing(2, 0, 0, 0),
  },
}));

export const SurveySectionContext = React.createContext<IQuestionType>({
  inputType: 1,
  minValue: 1,
  maxValue: 1,
  step: 1,
  instructions: "",
  keys: [],
});

const SurveySection: React.FC<ISurveySection> = (props: ISurveySection) => {
  const { questionGroups, questionType } = props;
  const classes = useStyles();
  return (
    <React.Fragment>
      <Paper className={classes.surveySection}>
        {questionType.instructions
          .split("\n")
          .map((line: string, lineNumber: number) => (
            <p key={lineNumber}>{line}</p>
          ))}
        <SurveySectionContext.Provider value={questionType}>
          {Object.values(questionGroups).map(
            (questionGroup: IQuestionGroup, index: number) => {
              return (
                <Grid key={index} item className={classes.questionGroup}>
                  <QuestionGroup {...questionGroup} />
                </Grid>
              );
            }
          )}
        </SurveySectionContext.Provider>
      </Paper>
    </React.Fragment>
  );
};

export default SurveySection;
